/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticket_Filter_AllInputs */

const en_ticket_filter_all = /** @type {(inputs: Ticket_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const ja_ticket_filter_all = /** @type {(inputs: Ticket_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて`)
};

const fr_ticket_filter_all = /** @type {(inputs: Ticket_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tous`)
};

const de_ticket_filter_all = /** @type {(inputs: Ticket_Filter_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Ticket_Filter_AllInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const ticket_filter_all = /** @type {((inputs?: Ticket_Filter_AllInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticket_Filter_AllInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticket_filter_all(inputs)
	if (locale === "ja") return ja_ticket_filter_all(inputs)
	if (locale === "fr") return fr_ticket_filter_all(inputs)
	return de_ticket_filter_all(inputs)
});